import React from 'react';
import _ from "lodash";
import { compose, withApollo } from 'react-apollo';
import { UpdateLitigation } from '../../../mutations/UpdateLitigation';
import TaskView from './TaskView';
import withClaimQuery from './withClaimQuery';
import withEligibleCountriesOptions from '../../HOC/withEligibleCountriesOptions';

class HandleNeb extends React.Component {
  state = {};

  get lawyer() {
    const { lawyer } = this.state;
    const { claim } = this.props;
    if (lawyer) return lawyer;
    if (this.litigationCountry === 'other') return '0';
    const lawyerId = _.get(claim, "lawyer.id");
    return lawyerId;
  }

  get litigationCountry() {
    const { litigationCountry } = this.state;
    const { eligibleCountriesOptions, claim } = this.props;
    const litigation_country = _.get(claim, "litigationCountry");
    if (litigationCountry) return litigationCountry;

    if (litigation_country && eligibleCountriesOptions.length) {
      const isCountryInOptions =
        eligibleCountriesOptions &&
        eligibleCountriesOptions.some(
          option => option.value === litigation_country
        );
      return isCountryInOptions ? litigation_country : 'other';
    }

    return 'other';
  }

  handleDropdownChange = (e, { name, value }) =>
    this.setState({ [name]: value });

  handleLitigationUpdate = () => {
    const { litigationCountry, lawyer } = this.state;
    const { task, onTaskComplete, client } = this.props;
    this.setState({ loading: true });
    const input = {
      taskId: task.id,
      litigationCountry:
        litigationCountry === 'other' ? null : litigationCountry,
      lawyerId: lawyer === '0' ? null : lawyer
    };

    client
      .mutate({
        mutation: UpdateLitigation,
        variables: { input }
      })
      .then(() => {
        onTaskComplete();
        this.setState({ loading: false });
      })
      .catch(error => this.setState({ loading: false }));
  };

  render = () => {
    const {
      claim,
      task,
      loading,
      onClaimClosed,
      eligibleCountriesOptions
    } = this.props;
    return (
      <TaskView
        onDropdownChange={this.handleDropdownChange}
        onLitigationUpdate={this.handleLitigationUpdate}
        litigationCountry={this.litigationCountry}
        lawyer={this.lawyer}
        eligibleCountriesOptions={eligibleCountriesOptions}
        loading={loading || this.state.loading}
        hideClaim={false}
        hideCloseClaimBtn
        claim={claim}
        task={task}
        onClaimClosed={onClaimClosed}
      />
    );
  };
}

const HandleNebWithData = compose(
  withClaimQuery,
  withApollo,
  withEligibleCountriesOptions
)(HandleNeb);

export default HandleNebWithData;



// WEBPACK FOOTER //
// ./src/component/tasks/HandleNebTask/index.js